import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Spinner = styled(FontAwesomeIcon)`
  color: #fff;
  margin-left: 8px;
`
